import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { map } from 'rxjs/operators';
import { IDocumentItem } from '../../interfaces/IDocumentItem';
import { IDocumentListResponse } from '../../interfaces/IDocumentListResponse';

@Injectable()
export class DocumentsProxyService {
  constructor(private httpClient: HttpClient) {}

  getDocuments(): Observable<IDocumentItem[]> {
    return this.httpClient.get<IDocumentListResponse>('api/Documents/List').pipe(map(response => this.parse(response)));
  }

  private parse(data: IDocumentListResponse): IDocumentItem[] {
    if (data.error === 0) {
      return data.documents;
    }
    throw data;
  }
}
